import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { createDocumentSlice } from 'store/Document';
import { createDocumentTemplateSlice } from './DocumentTemplate';
import { createDocumentModeSlice } from './DocumentMode';
import { createLayoutSlice } from './Layout';
import { createDocumentPrintSlice } from './DocumentPrint';
import { createSectionSlice } from './Section';
import { createEntityHistorySlice, EntityHistorySliceState } from './EntityHistory';
import {
  DocumentModeSliceState,
  DocumentTemplateSliceState,
  DocumentSearchSliceState,
  DocumentSliceState,
  LayoutSliceState,
  DocumentPrintSliceState,
  SectionSliceState,
  DocumentPublishSliceState,
} from './types';
import { createDocumentSearchSlice } from './DocumentSearch';
import { createDialogSlice, DialogSliceState } from './Dialog';
import { createDocumentPublishSlice } from './DocumentPublish';
import { createDocumentReviewSlice, DocumentReviewSliceState } from './DocumentReview';

export type BoundStoreState = DocumentTemplateSliceState
		& DocumentSliceState
		& DocumentModeSliceState
		& DocumentSearchSliceState
		& LayoutSliceState
		& DialogSliceState
		& DocumentPrintSliceState
		& SectionSliceState
		& DocumentPublishSliceState
		& DocumentReviewSliceState
		& EntityHistorySliceState;

export const useBoundStore = create<BoundStoreState>()(
  subscribeWithSelector(
    (...a) => ({
      ...createDocumentTemplateSlice(...a),
      ...createDocumentModeSlice(...a),
      ...createDocumentSearchSlice(...a),
      ...createDocumentSlice(...a),
      ...createLayoutSlice(...a),
      ...createDialogSlice(...a),
      ...createDocumentPrintSlice(...a),
      ...createSectionSlice(...a),
      ...createDocumentPublishSlice(...a),
      ...createDocumentReviewSlice(...a),
      ...createEntityHistorySlice(...a),
    }),
  ),
);